// eslint-disable-next-line no-useless-escape
export const Regex = new RegExp(/^[\[0-9-\]NXZ\.\*]+$/);
